module.exports = __webpack_public_path__ + "img/disability-assist-logo-white.54be9026.png";